import ProductGrid from "@/components/ProductGrid";

export default function Soaps() {
  return (
    <ProductGrid
      category="soaps"
      eyebrow="Handmade Soaps"
      title="Gentle. Grounding. Pure."
      blurb="Small-batch soap bars poured with nourishing oils and delicate scent. Grab a single bar for $10 — or lock in 3 for $27."
    />
  );
}
